import { render, staticRenderFns } from "./FamZoomCard.vue?vue&type=template&id=0db3f513&scoped=true&lang=pug"
import script from "./FamZoomCard.vue?vue&type=script&lang=js"
export * from "./FamZoomCard.vue?vue&type=script&lang=js"
import style0 from "./FamZoomCard.vue?vue&type=style&index=0&id=0db3f513&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db3f513",
  null
  
)

export default component.exports